import ApiHelper from "../../helpers/ApiHelper";
import BaseService from "../BaseService";

class DeliveryMethodService extends BaseService {

    static url = "delivery_methods";
    static apis = {
        get: { path: "", method: "get" },
    }

    constructor(repo) {
        super(repo);
        this.repo = new ApiHelper("delivery_methods");
    }

}

export default DeliveryMethodService;